import AppsContainer from "../../components/UmmIACategories/AppsContainer";
import HeaderCategoria from "../../components/UmmIACategories/HeaderCategoria";
import UmmIAComTitleImg from "../../components/UmmIACategories/img/UmmIAComTitleImg.png";

const UmmIAComPage = () => {
  return (
    <>
      {/* Contenedor de cabecera */}
      <HeaderCategoria
        titulo="UmmIACom"
        descripcion="Aplicaciones para apoyar tu gestión y comunicaciones"
        img={UmmIAComTitleImg}
        alt="Imagen UmmIA Com"
        primaryColor="#6A93A8"
        secondaryColor="#C3D4DC"
        thirdColor="#88A9B9"
      />

      {/* Contenedor de tarjetas: se renderizan solo las apps a las que el usuario tiene acceso */}
      <AppsContainer filter="UmmIACom" />
    </>
  );
};

export default UmmIAComPage;
